import {animate, query, stagger, style, transition, trigger} from "@angular/animations";

export const listAnimation = trigger('listAnimation', [
  transition('* <=> *', [
    query(':enter',
      [style({ transform: 'scale(0)' }), stagger('500ms', animate('70ms ease-out', style({ transform: 'scale(1)' })))],
      { optional: true }
    ),
    query(':leave',
      animate('100ms', style({ transform: 'scale(0)' })),
      { optional: true }
    )
  ])
]);
